import { IAddLogRequest, IDeleteAfter } from '@principle-theorem/shared';

export interface IManagementJobLog extends IAddLogRequest, IDeleteAfter {}
